/**
 * Decodifica entidades HTML (`&amp;`, `&#39;`, `&ccedil;`, `&nbsp;`) usando o parser do próprio
 * browser, no lugar do pacote `he`.
 *
 * POR QUÊ: o `he` custava **121 KB de fonte / ~30 KB comprimidos no vendor** (medido em
 * 17/09/2026 com `--stats-json` e um build de prova) no bundle que TODA visita baixa antes de
 * ver o cardápio — para servir a uma única chamada, a `UtilsService.removeTags`, que limpa a
 * descrição do produto. Era a maior peça de biblioteca do boot que não fazia parte do Angular.
 *
 * COMO: o conteúdo de um `<textarea>` é RCDATA — o parser resolve as referências de caractere
 * (as ~2.200 nomeadas e as numéricas, decimais e hexadecimais) e não cria elementos. É o mesmo
 * algoritmo que o navegador aplica à página, então a tabela está sempre completa e atualizada,
 * sem custo de bundle.
 *
 * SEGURANÇA: nenhum `<` chega ao parser. Trocamos cada `<` por um sentinela ANTES de escrever
 * no elemento e o devolvemos depois — sem `<` não existe tag, então não há como um
 * `</textarea><img src=x onerror=…>` vindo da descrição de um produto sair do RCDATA e criar
 * um elemento (que, mesmo solto fora do documento, dispararia o `onerror`). O `&lt;` continua
 * virando `<`, porque quem o produz é o decodificador, não uma segunda passada do parser.
 *
 * Sem `document` (prerender/SSR, unit test em Node) devolve a entrada intacta — o mesmo que o
 * `catch` do `removeTags` já fazia.
 */

/** Caractere de controle que nunca aparece em texto de cardápio; some da entrada, por garantia. */
const SENTINELA = '';

let area: HTMLTextAreaElement | null = null;

export function decodificarEntidadesHtml(entrada: string): string {
	// Atalho que vale para a esmagadora maioria das descrições: sem `&` não há o que decodificar,
	// e assim nem tocamos no DOM no caminho quente do render do cardápio.
	if (!entrada || entrada.indexOf('&') === -1) return entrada;
	if (typeof document === 'undefined') return entrada;

	if (!area) area = document.createElement('textarea');
	const protegido = entrada.split(SENTINELA).join('').split('<').join(SENTINELA);
	area.innerHTML = protegido;
	return area.value.split(SENTINELA).join('<');
}
